import {DonationServiceLoading, IInternalState} from "./context";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {IDonationService, IDonationServiceDetails} from "../../models/donation-service/response";
import {IDonationServiceQuery} from "../../models/donation-service/query";
import paramsReducer, {QueryAction} from "../base/base-reducer";
import toggleLoading from "../../utils/helpers/xor";

type Action =
    | {
    type: "LOADING";
    payload: { loading: DonationServiceLoading | DonationServiceLoading[] };
}
    | { type: "SET_LIST"; payload: { list: IBaseListingResponse<IDonationService> } }
    | { type: "SET_DETAILS"; payload: { details?: IDonationServiceDetails } }
    | QueryAction<IDonationServiceQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
    switch (action.type){
        case "LOADING": {
            return {
                ...state,
                loading: toggleLoading(state.loading, action.payload.loading),
            };
        }
        case "SET_LIST": {
            return {
                ...state,
                list: action.payload.list,
            };
        }
        case "SET_DETAILS": {
            return {
                ...state,
                details: action.payload.details,
            };
        }
        default: {
            return paramsReducer(state, action);
        }
    }
}

export default reducer;